import { useEffect, useState } from 'react';
import { pendingWorkedValidationHeader } from './data'
import TablePagination from '@mui/material/TablePagination';
import API from 'Api';
import exportIcon from '../../assets/icons/export.svg';
// import * as XLSX from "xlsx";
import XLSX from "xlsx-js-style";
import { IconButton } from '@mui/material';
import NoRecordFound from './noRecordFound';
import { dateConvertToUSTime, formatPhoneNumber, formatToMMDDYYYY } from "components/helper/helper";
import Loader from 'react-loader-spinner';
import ruleoutLogo from '../../assets/icons/logo2.svg';
import {
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";

const DenialTable = ({ filterType, showLoader }) => {
    let rowCount = 1000;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(rowCount);
    const [denialList, setDenialList] = useState([])
    const [pendingList, setPendingList] = useState([])
    const [completedList, setCompletedList] = useState([])
    const [totalRecord, setTotalRecord] = useState(0)
    const [showLoaderOnCountChange, setShowLoaderOnCountChange] = useState(false);
    const [showCancelLoader, setShowCancelLoader] = useState(false);

    let practice = JSON.parse(sessionStorage.getItem("practice"))?.id

    const getData = async ({ filterType = null, limit = rowsPerPage, pgPage = page }) => {
        setShowLoaderOnCountChange(true);
        let chargesTimer = setTimeout(() => setShowCancelLoader(!showCancelLoader), 15000)
        setDenialList([])
        setTotalRecord(0)
        setCompletedList([])
        try {
            if (filterType === 'completed') {
                let result = await API.get(`/getCompletedList?page=${pgPage}&limit=${limit}`)
                clearTimeout(chargesTimer);
                setShowLoaderOnCountChange(false);
                if (result.data.success === true) {
                    setDenialList(result.data.data)
                    setTotalRecord(result.data.pagination.totalRecords)
                    setCompletedList(result.data.data)
                }
            } else {
                let result = await API.get(`/getPendingWorkedValidation?page=${pgPage}&limit=${limit}`)
                setShowLoaderOnCountChange(false);
                if (result.data.success === true) {
                    setDenialList(result.data.data)
                    setTotalRecord(result.data.pagination.totalRecords)
                    setPendingList(result.data.data)
                }
            }
        } catch (error) {

        } finally {
            setShowCancelLoader(false)
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        getData({ pgPage: newPage, filterType })
    };

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        let limit = parseInt(event.target.value)
        setRowsPerPage(limit);
        getData({ limit, pgPage: 0, filterType })
    };

    const resetStates = () => {
        setDenialList([])
        setTotalRecord(0)
        setPage(0)
    }

    useEffect(() => {
        if (filterType === 'pendingWorkedValidation') {
            getData({ limit: rowsPerPage })
        } else if (filterType === 'completed') {
            resetStates();
            getData({ filterType, limit: rowsPerPage })
        }
    }, [filterType, practice])

    // function to export pending and completed list
    // const exportDenialPendingOrCompleted = () => {
    //     let practice = JSON.parse(sessionStorage.getItem("practice"))
    //     let exportedExcelName;
    //     if (filterType == "completed") {
    //         if (practice == "all") {
    //             exportedExcelName = "All Practices-Denials-Completed";
    //         } else {
    //             exportedExcelName = `${practice?.practiceAcronym}-Denials-Completed`;
    //         }
    //     } else {
    //         if (practice == "all") {
    //             exportedExcelName = "All Practices-Denials-Pending Worked Validation";
    //         } else {
    //             exportedExcelName = `${practice?.practiceAcronym}-Denials-Pending Worked Validation`;
    //         }
    //     }
    //     let exportedDenialData = [];
    //     let denialPendingOrCompleted = filterType === "completed" ? completedList : pendingList;
    //     denialPendingOrCompleted.map(item => {
    //         const newItem = {};
    //         newItem["PracticeName"] = item.PracticeName;
    //         newItem["CustomerID"] = Number(item.CUSTOMERID);
    //         newItem["ClaimID"] = Number(item.CLAIMID);
    //         newItem["EncounterID"] = Number(item.EncounterID);
    //         newItem["PatientID"] = Number(item.PATIENTID);
    //         newItem["PatientName"] = item.PatientName;
    //         newItem["DOB"] = formatToMMDDYYYY(item.DOB);
    //         newItem["ServiceStartDate"] = formatToMMDDYYYY(item.ServiceStartDate);
    //         newItem["RenderingProviderID"] = Number(item.RENDERING_PROVIDER_ID);
    //         newItem["RenderingProviderName"] = item.RENDERING_PROVIDER_NAME;
    //         newItem["SchedulingProviderID"] = Number(item.SCHEDULING_PROVIDER_ID);
    //         newItem["SchedulingProviderName"] = item.SchedulingProviderName;
    //         newItem["ServiceLocationName"] = item.ServiceLocationName;
    //         newItem["InsPhone"] = formatPhoneNumber(item.InsPhone);
    //         newItem["PolicyNumber"] = item.PolicyNumber;
    //         newItem["BilledTo"] = item.Billed_to;
    //         newItem["InsPlanID"] = Number(item.InsPlanID);
    //         newItem["Code"] = item.Code;
    //         newItem["Mod1"] = item.Mod;
    //         newItem["DXC1"] = item.DXC1;
    //         newItem["TotalCharge"] = Number(item.Total_Charge);
    //         newItem["Balance"] = Number(item.Balance);
    //         newItem["AdjCode"] = item.Adj_Code;
    //         newItem["Remark"] = item.Remark;
    //         newItem["Advice"] = item.ADVICE;
    //         newItem["Issue Type"] = item.issueType;
    //         newItem["DenialDate"] = formatToMMDDYYYY(item.Denial_Date);
    //         newItem["PaymentID"] = Number(item.PAYMENTID);
    //         newItem["Status"] = filterType == "workList" ? "Worklist" : filterType == "completed" ? "Completed" : "Pending Worked Validation";
    //         newItem["Redenied"] = item.Redenied == false || item.Redenied == null ? "No" : "Yes";
    //         newItem["AssignedTo"] = item.AssignedTo;
    //         newItem["WhatsNeeded"] = item.WhatsNeeded;
    //         newItem["DueDate"] = formatToMMDDYYYY(item.DueDate);
    //         newItem["ActionTaken"] = item.ActionTaken;
    //         newItem["CompletedBy"] = item.CompletedBy;
    //         newItem["DateCompleted"] = new Date(item.DateCompleted).toLocaleDateString('en-US', { month: "2-digit", day: "2-digit", year: "numeric" });
    //         newItem["LastNote"] = item.Notes[0] != undefined ? item.Notes[0].NOTES : "";
    //         newItem["CreatedOn"] = item.created_at;
    //         newItem["UpdatedOn"] = item.updated_at;
    //         exportedDenialData.push(newItem);
    //     })
    //     const worksheet = XLSX.utils.json_to_sheet(exportedDenialData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Denial Data");
    //     XLSX.writeFile(workbook, `${exportedExcelName}.xlsx`);
    // }


    const exportDenialPendingOrCompleted = () => {
        let practice = JSON.parse(sessionStorage.getItem("practice"))
        let exportedExcelName;
        if (filterType == "completed") {
            if (practice == "all") {
                exportedExcelName = "All Practices-Denials-Completed";
            } else {
                exportedExcelName = `${practice?.practiceAcronym}-Denials-Completed`;
            }
        } else {
            if (practice == "all") {
                exportedExcelName = "All Practices-Denials-Pending Worked Validation";
            } else {
                exportedExcelName = `${practice?.practiceAcronym}-Denials-Pending Worked Validation`;
            }
        }
        let denialPendingOrCompleted = filterType === "completed" ? completedList : pendingList;

        // const toExcelDateMidnightUTC = (formattedDate) => {
        //     let value;
        //     if (/^\d{2}\/\d{2}\/\d{4}$/.test(formattedDate)) {
        //         value = formattedDate;
        //     } else {
        //         value = formatToMMDDYYYY(formattedDate);
        //     }
        //     if (!value) return null;
        //     const d = new Date(value);
        //     const utcDate = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        //     const epoch = new Date(Date.UTC(1899, 11, 30));
        //     return (utcDate - epoch) / (24 * 60 * 60 * 1000);
        // };

        // correct except created and updated date
        // const toExcelDateMidnightUTC = (formattedDate) => {
        //     if (!formattedDate) return null;

        //     let date;
        //     // Check if the date string contains time information (indicated by 'T')
        //     if (formattedDate.includes('T')) {
        //         // For dates with time, create a Date object directly.
        //         // It will be parsed correctly with the timezone information.
        //         date = new Date(formattedDate);
        //     }
        //     // else if (formattedDate.includes(' ')) {
        //     //     const correctDate = formattedDate.split(' ')[0]
        //     //     console.log(correctDate)
        //     //     // let d = new Date(correctDate).toLocaleDateString('en-US')
        //     //     const [year, month, day] = correctDate.split('-').map(Number);
        //     //     date = new Date(year, month - 1, day); // month is 0-indexed
        //     // } 
        //     else {
        //         // For date-only strings (like "2025-09-21"), construct it manually
        //         // to ensure it is treated as local midnight, not UTC midnight.
        //         const [year, month, day] = formattedDate.split('-').map(Number);
        //         date = new Date(year, month - 1, day); // month is 0-indexed
        //     }

        //     // Handle invalid dates
        //     if (isNaN(date.getTime())) {
        //         console.error('Invalid date received:', formattedDate);
        //         return null;
        //     }

        //     // Calculate the Excel date number based on the Excel epoch
        //     const excelEpoch = new Date(Date.UTC(1899, 11, 30));
        //     return (date.getTime() - excelEpoch.getTime()) / (24 * 60 * 60 * 1000);
        // };

        const toExcelDateMidnightUTC = (formattedDate) => {
            if (!formattedDate) return null;

            let date;

            // Check if the date string includes time information (indicated by 'T' or a space)
            if (formattedDate.includes('T') || formattedDate.includes(' ')) {
                // If a time component exists, create a Date object and then zero out the time.
                date = new Date(formattedDate);
                if (isNaN(date.getTime())) {
                    console.error('Invalid date received:', formattedDate);
                    return null;
                }
                // Zero out the time components to get the start of the day in local time
                date.setHours(0, 0, 0, 0);

            } else {
                // For date-only strings (like "2025-09-21"), construct it manually
                // to ensure it is treated as local midnight, not UTC midnight.
                const [year, month, day] = formattedDate.split('-').map(Number);
                date = new Date(year, month - 1, day); // month is 0-indexed
            }

            // Handle invalid dates
            if (isNaN(date.getTime())) {
                console.error('Invalid date received:', formattedDate);
                return null;
            }

            // Create a new date at UTC midnight to perform the Excel number calculation
            // This is the most reliable way to prevent timezone shifts
            const utcMidnightMillis = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

            // Calculate the Excel date number based on the Excel epoch
            const excelEpoch = new Date(Date.UTC(1899, 11, 30));
            return (utcMidnightMillis - excelEpoch.getTime()) / (24 * 60 * 60 * 1000);
        };

        const exportColumns = [
            { key: "PracticeName" },
            { key: "CustomerID", type: "integer" },
            { key: "ClaimID", type: "integer" },
            { key: "EncounterID", type: "integer" },
            { key: "PatientID", type: "integer" },
            { key: "PatientName" },
            { key: "DOB", type: "date" },
            { key: "ServiceStartDate", type: "date" },
            { key: "RenderingProviderID", type: "integer" },
            { key: "RenderingProviderName" },
            { key: "SchedulingProviderID", type: "integer" },
            { key: "SchedulingProviderName" },
            { key: "ServiceLocationName" },
            { key: "InsPhone", type: "text" },
            { key: "PolicyNumber" },
            { key: "BilledTo" },
            { key: "InsPlanID", type: "integer" },
            { key: "Code" },
            { key: "TotalCharge", type: "decimal" },
            { key: "Balance", type: "decimal" },
            { key: "AdjCode" },
            { key: "Remark" },
            { key: "Advice" },
            { key: "Issue Type" },
            { key: "DenialDate", type: "date" },
            { key: "PaymentID" },
            { key: "Status" },
            { key: "Redenied" },
            { key: "AssignedTo" },
            { key: "WhatsNeeded" },
            { key: "DueDate", type: "date" },
            { key: "ActionTaken" },
            { key: "CompletedBy" },
            { key: "DateCompleted", type: "date" },
            { key: "LastNote" },
            { key: "CreatedOn", type: "date" },
            { key: "UpdatedOn", type: "date" }
        ];

        const sanitizedData = denialPendingOrCompleted.map(item => ({
            PracticeName: item.PracticeName,
            CustomerID: Number(item.CUSTOMERID),
            ClaimID: Number(item.CLAIMID),
            EncounterID: Number(item.EncounterID),
            PatientID: Number(item.PATIENTID),
            PatientName: item.PatientName,
            DOB: toExcelDateMidnightUTC(item.DOB),
            ServiceStartDate: toExcelDateMidnightUTC(item.ServiceStartDate),
            RenderingProviderID: Number(item.RENDERING_PROVIDER_ID),
            RenderingProviderName: item.RENDERING_PROVIDER_NAME,
            SchedulingProviderID: Number(item.SCHEDULING_PROVIDER_ID),
            SchedulingProviderName: item.SchedulingProviderName,
            ServiceLocationName: item.ServiceLocationName,
            InsPhone: formatPhoneNumber(item.InsPhone),
            PolicyNumber: item.PolicyNumber,
            BilledTo: item.Billed_to,
            InsPlanID: Number(item.InsPlanID),
            Code: item.Code,
            Mod1: item.Mod,
            DXC1: item.DXC1,
            TotalCharge: Number(item.Total_Charge),
            Balance: Number(item.Balance),
            AdjCode: item.Adj_Code,
            Remark: item.Remark,
            Advice: item.ADVICE,
            IssueType: item.issueType,
            DenialDate: toExcelDateMidnightUTC(item.Denial_Date),
            PaymentID: Number(item.PAYMENTID),
            Status: filterType == "workList" ? "Worklist" : filterType == "completed" ? "Completed" : "Pending Worked Validation",
            Redenied: item.Redenied == false || item.Redenied == null ? "No" : "Yes",
            AssignedTo: item.userName,
            WhatsNeeded: item.WhatsNeeded,
            DueDate: toExcelDateMidnightUTC(item.DueDate),
            ActionTaken: item.ActionTaken,
            CompletedBy: item.CompletedBy,
            DateCompleted: toExcelDateMidnightUTC(item.DateCompleted),
            LastNote: item.Notes[0] != undefined ? item.Notes[0].NOTES : "",
            CreatedOn: toExcelDateMidnightUTC(item.created_at),
            UpdatedOn: toExcelDateMidnightUTC(item.updated_at),
        }))

        // Convert to array of arrays (values only, no headers)
        // const dataOnly = sanitizedData.map(item =>
        //     exportColumns.map(col => item[col.key])
        // );
        // console.log(dataOnly)

        // const worksheet = XLSX.utils.aoa_to_sheet(dataOnly);
        // XLSX.utils.sheet_add_aoa(
        //     worksheet,
        //     [exportColumns.map(col => col.key)], // build header row from exportColumns
        //     { origin: "A1" }
        // );

        const dataOnly = sanitizedData.map(item =>
            exportColumns.map(col => item[col.key])
        );

        // Create a new empty worksheet
        const worksheet = XLSX.utils.aoa_to_sheet([]);

        // 1. Add the header row starting at A1
        XLSX.utils.sheet_add_aoa(worksheet, [exportColumns.map(col => col.key)], { origin: "A1" });

        // 2. Add the data starting from A2 (after the header)
        XLSX.utils.sheet_add_aoa(worksheet, dataOnly, { origin: "A2" });


        // Apply styles
        exportColumns.forEach((col, colIndex) => {
            const colLetter = XLSX.utils.encode_col(colIndex);
            for (let rowIndex = 1; rowIndex <= sanitizedData.length + 1; rowIndex++) {
                const cellAddress = `${colLetter}${rowIndex}`;
                const cell = worksheet[cellAddress];
                if (cell) {
                    if (col.type === "integer") {
                        cell.s = { numFmt: "0" };
                    } else if (col.type === "decimal") {
                        cell.s = { numFmt: "0.00" };
                    } else if (col.type === "date") {
                        cell.s = { numFmt: "mm/dd/yyyy" };
                    }
                }
            }
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Denial Data");
        XLSX.writeFile(workbook, `${exportedExcelName}.xlsx`, {
            Props: { Title: exportedExcelName }
        });
    };


    const styles = {
        content: {
            width: '100%',
            marginTop: '0rem',
            // padding: '0rem 0rem 1rem 1.5rem',
            // border: '0px !important',
            // position: 'absolute'
        }
    }

    const getColour = (actionName) => {

        let colour = ''
        switch (actionName) {
            case 'Fixed Posting Error':
                colour = '#5CB02C'
                break
            case 'Appealed':
            case 'Rebilled':
            case 'Corrected Claim':
            case 'Phone Reopening':
            case 'Ins Transfer':
                colour = '#C88700'
                break
            case 'Patient Billed':
                colour = '#0097FA'
                break
            case 'Settled':
            case 'Voided':
                colour = '#EB0000'
                break
            case 'Remove':
            case 'Unknown':
                colour = '#535353'
                break
            default:
                break
        }
        return colour
    }

    const formatDateToMMDDYYYY_UTC = (dateStr) => {
        const dateObj = new Date(dateStr);
        // Use UTC methods to ignore local timezone offset
        const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0'); // getUTCMonth() is 0-indexed
        const day = String(dateObj.getUTCDate()).padStart(2, '0');
        const year = dateObj.getUTCFullYear();

        return `${month}/${day}/${year}`;
    };

    return <div style={styles.content}>
        <div className={`1pt-4 table-responsive custom-size tableresponsivecustom PendingWorkedtable denial-style w-100 }`}>
            { } <table className="denial-table">
                <thead>
                    <tr>
                        {pendingWorkedValidationHeader.map((col, index) => (
                            <th className='text-center' key={index} >
                                <span>{col.name}</span>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {!denialList?.length && !showLoader ? <NoRecordFound /> : denialList?.length > 0 && denialList?.map((data, idx) => (
                        <tr style={{ cursor: 'pointer' }} key={idx} className='table-row'>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.CLAIMID}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.EncounterID}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <span title={data.PatientName} className='deal-content'>{data.PatientName}</span>
                                </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{dateConvertToUSTime(data.ServiceStartDate)}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <span title={data.SchedulingProviderName} className='deal-content'>{data.SchedulingProviderName}</span>
                                </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <span title={data.ServiceLocationName} className='deal-content'>{data.ServiceLocationName}</span>
                                </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <span title={data.Billed_to} className='deal-content'>{data.Billed_to}</span>
                                </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.Code}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.Mod}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.DXC1}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.Total_Charge}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.Balance}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{(data.Redenied == false || data.Redenied == null) ? "No" : "Yes"}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <div className='innerdata'>{data.Adj_Code}</div>
                                </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <span title={data.Remark} className='one-line-ellipsis'>{data.Remark}</span>
                                </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <span title={data.WhatsNeeded} className='deal-content'>{data.WhatsNeeded}</span>
                                </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <span title={data.CompletedBy} className='deal-content'>{data.CompletedBy}</span>
                                </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                {/*<div className='innerdata'>{data.DateCompleted != null ? new Date(data.DateCompleted).toLocaleDateString('en-US', {
                                    month: "2-digit", day: "2-digit", year: "numeric"
                                }) : ""}</div>*/}
                                <div className='innerdata'>{data.DateCompleted != null ? formatDateToMMDDYYYY_UTC(data.DateCompleted) : ""}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata' >
                                    <span className='action-taken' style={{ backgroundColor: getColour(data.ActionTaken) }}>
                                        {data.ActionTaken}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className='rule-footer'>
                <div className='foot-flex'>
                    {/* <div className='foot-right3'> */}
                    <div >
                        <div>
                            <span className="text-dark font-face-futura">
                                <span className='fontw'>Total Encounters: <span className='fw-normal'>{totalRecord}</span></span>
                            </span>
                            <IconButton className='export-container'>
                                <div className='export-btn'>
                                    <input
                                        type="image"
                                        src={exportIcon}
                                        alt="exportDenial"
                                        className="mx-1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => exportDenialPendingOrCompleted()}
                                    />
                                    <span className='export'>Export</span>
                                </div>
                            </IconButton>
                        </div>
                    </div>
                    {/* <div className='ms-auto'> */}
                    {/* <div style={{ marginLeft: props.ruleSuccess ? '0px' : '110px' }}> */}
                    <div style={{ display: "flex" }}>

                        <TablePagination
                            component="p"
                            count={totalRecord}
                            page={page}
                            rowsPerPageOptions={[rowCount, 2000, 4000]}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            className='pendingtable-pagination'
                        />
                        {/* </div> */}
                    </div>
                </div>
            </div>
        </div>
        {
            showLoaderOnCountChange &&
            <Dialog
                fullWidth
                open={showLoaderOnCountChange}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <div align="center" className={showCancelLoader ? 'avatar2' : 'avatar'}>
                    <img src={ruleoutLogo} alt="ruleout" className='ruleoutLogo' />
                    <Loader className="mt-2" type='Oval'
                        height={180}
                        width={195}
                        color="#5CB02C"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel='oval-loading'
                        secondaryColor="#5CB02C"
                        strokeWidth={2}
                        strokeWidthSecondary={2} />
                </div>
                <div align="center" className={showCancelLoader ? 'dialog-box2' : 'dialog-box'}>
                    <DialogTitle id="alert-dialog-title">
                        <span className='font-face-futura dialogTitle'>{"Updating Denials"}</span>
                    </DialogTitle>
                    {showCancelLoader ?
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                <span className='dialogText'>Hold tight while we fetch a new list of denials!</span>
                            </DialogContentText><br />
                            <DialogContentText id="alert-dialog-description">
                                <span className='dialogText'>Hmm... This is taking longer than expected.</span><br />
                                <span className='dialogText'>Give us a little bit longer</span>
                            </DialogContentText>
                            <Button fullWidth className='mt-4 dialogBtn' variant='contained' onClick={() => window.location.reload()}>
                                <span className='font-face-futura'>Cancel</span>
                            </Button>
                        </DialogContent> :
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                <span className='font-face-futura dialogText'>Let's get you a new list of denials!</span>
                            </DialogContentText>
                        </DialogContent>}
                </div>
            </Dialog>
        }
    </div>
}

export {
    DenialTable
}